/*@flow*/
import * as I from 'immutable';
import type { StateT, Action } from './types';
import setIn from 'lib/setIn';
import mkDistrict from './mkDistrict';

export default (state: I.RecordOf<StateT>, action: Action) => {
  const { type, payload } = action;
  let newState = state;
  switch (type) {
    case 'MODE_CHANGE':
      if (payload) {
        newState = newState.set('mode', payload);
      }
      break;
    case 'SET_RECORD':
      if (payload) {
        newState = setIn(newState)(payload);
      }
      break;
    case 'DRAWING_CANCELLED':
      newState = newState
        .setIn(['areaWorkingCopy', 'geojson'], '')
        .set('mode', 'READY');
      break;
    case 'AREA_CLEARED':
      newState = newState
        .update('areaWorkingCopy', (v) => v.clear())
        .update('areaBackup', (v) => v.clear());
      break;
    case 'AREA_SELECTED':
      newState = newState
        .update('areaWorkingCopy', () =>
          payload ? mkDistrict(payload) : mkDistrict()
        )
        .update('areaBackup', () =>
          payload ? mkDistrict(payload) : mkDistrict()
        );
      break;
    case 'AREA_SAVED':
    case 'MAP_SHARED':
      // $FlowFixMe[incompatible-call]
      newState = newState.update((v) => {
        const v2 = v.set(
          'areaWorkingCopy',
          payload ? mkDistrict(payload) : mkDistrict()
        );
        return v2.set('areaBackup', v2.get('areaWorkingCopy'));
      });
      break;
    case 'AREA_CLONED':
      // Duplicate the working copy and remove its id and dashboard id
      // $FlowFixMe[incompatible-call]
      newState = newState.update((v) =>
        v
          .update('areaWorkingCopy', (v2) =>
            v2
              .remove('id')
              .remove('name')
              .remove('dashboardId')
          )
          .update((v2) => v2.set('areaBackup', v2.get('areaWorkingCopy')))
          .set('showEditOverlay', true)
      );
      break;
    default:
      throw new Error('Unrecognized action `' + type + '`');
  }
  return newState;
};
